export default __webpack_public_path__ + "static/sprite-92bd241d511001b1a6b6a70ad7d525cc.svg";